import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { Typography } from "@/components/ui/typography";
import addCardLight from "@/assets/svg/AddCardLight.svg";
import addCardDark from "@/assets/svg/AddCardDark.svg";

interface DroppableColumnProps {
  id: string;
  children: React.ReactNode;
  hasCards?: boolean;
}

const DroppableColumn: React.FC<DroppableColumnProps> = ({ id, children, hasCards = false }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      ref={setNodeRef}
      style={{ minWidth: 0 }}
      className={`w-full min-h-[300px] rounded-lg border-2 border-dashed flex flex-col gap-3 p-3 
        ${isOver
          ? "border-primary-500 bg-primary-50 dark:bg-primary-900/20"
          : "border-grey-500 bg-grey-100 dark:border-grey-700 dark:bg-blue-700"
        }`}
    >
      {children}
      {!hasCards && (
        <div className="flex-1 flex flex-col items-center justify-center gap-3 min-h-[200px]">
          <img src={addCardLight} alt="add widget" className="block dark:hidden w-16 h-16" />
          <img src={addCardDark} alt="add widget" className="hidden dark:block w-16 h-16" />
          <Typography variant="medium-14" className="text-grey-500 text-center">
            Drag a Card to the column
          </Typography>
        </div>
      )}
    </div>
  );
};

export default DroppableColumn;
